import { Box } from '@mui/material'
import { UIModal } from 'features/UI'
import { UserNotification } from 'types'
import { useMemo } from 'react'

const DISABLED_UNSUBSCRIBE_HTML =
  '<span style="color: #999; text-decoration: none; cursor: not-allowed; pointer-events: none;">Unsubscribe</span>'

// Matches only the standalone "Unsubscribe" anchor, without swallowing other links or content
const UNSUBSCRIBE_LINK_REGEXP = /<a\b[^>]*>[^<]*[Uu]nsubscribe[^<]*<\/a>/g

const processNotificationMessage = (message: string, deliveredVia: string): string => {
  if (!message) return ''

  const deliveredViaLower = deliveredVia?.toLowerCase() || ''

  // If delivered via SMS, remove the unsubscribe link completely
  if (deliveredViaLower === 'sms') {
    return message.replace(UNSUBSCRIBE_LINK_REGEXP, '')
  }

  // If delivered via Email: show disabled Unsubscribe for all
  if (deliveredViaLower === 'email') {
    // Replace any existing unsubscribe link with disabled span
    let processed = message.replace(UNSUBSCRIBE_LINK_REGEXP, () => DISABLED_UNSUBSCRIBE_HTML)

    // If message had no unsubscribe link, append disabled Unsubscribe so every email popup shows it
    if (!processed.toLowerCase().includes('unsubscribe')) {
      processed = `${processed}<br><br>${DISABLED_UNSUBSCRIBE_HTML}`
    }

    return processed
  }

  return message
}

export function UserNotificationMessageModal({
  isOpen,
  onClose,
  notification,
}: {
  isOpen: boolean
  onClose: () => void
  notification: UserNotification | null
}) {
  const processedMessage = useMemo(() => {
    if (!notification) return ''
    return processNotificationMessage(notification.message, notification.deliveredVia)
  }, [notification])

  if (!notification) return null

  return (
    <UIModal
      title="Notification Message"
      isOpen={isOpen}
      onClose={onClose}
      width={800}
      maxWidth="90vw"
    >
      <Box
        sx={{
          maxHeight: '70vh',
          overflowY: 'auto',
          '& a': {
            color: 'primary.main',
            textDecoration: 'underline',
          },
        }}
        dangerouslySetInnerHTML={{ __html: processedMessage }}
      />
    </UIModal>
  )
}
